import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useForm from '@components/form/hooks/useForm';
import { postForgotPassword } from '@actions/auth/postForgotPassword';
import { getAuthError, getAuthIsPosting, getAuthPostSuccess } from '@selectors/auth';
import usePrevious from 'lib/src/hooks/usePrevious';
import { useHistory } from 'react-router-dom';

const useForgotPasswordForm = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const isPosting = useSelector(getAuthIsPosting);
    const postSuccess = useSelector(getAuthPostSuccess);
    const error = useSelector(getAuthError);

    const [{ email }, handleChange] = useForm({ email: '' });
    const [success, setSuccess] = useState(false);

    const prevPostSuccess = usePrevious(postSuccess);
    useEffect(() => {
        if (!prevPostSuccess && postSuccess) {
            setSuccess(true);
        }
    }, [dispatch, postSuccess, prevPostSuccess, setSuccess]);

    const handleCancel = () => {
        history.replace('/auth/login');
    };
    const handleSubmit = () => {
        dispatch(postForgotPassword({ email }));
    };

    return {
        email,
        handleChange,
        handleSubmit,
        isPosting,
        success,
        error,
        handleCancel,
    };
};

export default useForgotPasswordForm;
